import React from 'react';
import { Link } from 'react-router-dom';
import { TrophyIcon, UserGroupIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { AcademicCapIcon, CpuChipIcon } from '@heroicons/react/24/outline';

const BitPool = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-white">BitPool</h1>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {/* Duel Mode Card */}
        <Link to="/duel" className="bg-dark-lighter rounded-lg p-6 border border-gray-700 hover:border-primary transition-all hover:shadow-lg hover:shadow-purple-900/20">
          <div className="flex flex-col items-center text-center gap-4">
            <div className="bg-purple-800/30 p-4 rounded-full">
              <TrophyIcon className="h-12 w-12 text-purple-400" />
            </div>
            <h3 className="text-xl font-semibold text-white">Duel Mode</h3>
            <p className="text-gray-400 mb-4">Challenge other players to 1v1 pool matches and climb the leaderboard</p>
            <button className="w-full bg-primary hover:bg-primary/90 text-white px-4 py-3 rounded-lg font-medium">
              Play Duel Mode
            </button>
          </div>
        </Link>
        
        {/* AI Agent Card */}
        <Link to="/quests" className="bg-dark-lighter rounded-lg p-6 border border-gray-700 hover:border-primary transition-all hover:shadow-lg hover:shadow-blue-900/20">
          <div className="flex flex-col items-center text-center gap-4">
            <div className="bg-blue-800/30 p-4 rounded-full">
              <CpuChipIcon className="h-12 w-12 text-blue-400" />
            </div>
            <h3 className="text-xl font-semibold text-white">AI Agent</h3>
            <p className="text-gray-400 mb-4">Complete quests with the help of AI to earn rewards and improve your skills</p>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg font-medium">
              View Quests
            </button>
          </div>
        </Link>
        
        {/* Solo Play Card */}
        <a 
          href="https://play.bitpool.gg" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bg-dark-lighter rounded-lg p-6 border border-gray-700 hover:border-primary transition-all hover:shadow-lg hover:shadow-green-900/20"
        >
          <div className="flex flex-col items-center text-center gap-4">
            <div className="bg-green-800/30 p-4 rounded-full">
              <UserGroupIcon className="h-12 w-12 text-green-400" />
            </div>
            <h3 className="text-xl font-semibold text-white">Solo Play</h3>
            <p className="text-gray-400 mb-4">Practice your skills in single-player mode and master the game</p>
            <button className="w-full bg-green-600 hover:bg-green-700 text-white px-4 py-3 rounded-lg font-medium">
              Play Solo
            </button>
          </div>
        </a>
        
        {/* Pool Degen Card */}
        <a 
          href="https://t.me/pooldegen_bot" 
          target="_blank" 
          rel="noopener noreferrer"
          className="bg-dark-lighter rounded-lg p-6 border border-gray-700 hover:border-primary transition-all hover:shadow-lg hover:shadow-yellow-900/20"
        >
          <div className="flex flex-col items-center text-center gap-4">
            <div className="bg-yellow-800/30 p-4 rounded-full">
              <AcademicCapIcon className="h-12 w-12 text-yellow-400" />
            </div>
            <h3 className="text-xl font-semibold text-white">Pool Degen</h3>
            <p className="text-gray-400 mb-4">Join the Pool Degen community on Telegram and connect with other players</p>
            <button className="w-full bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-3 rounded-lg font-medium">
              Join Pool Degen
            </button>
          </div>
        </a>
      </div>
      
      <div className="mt-12">
        <h2 className="text-xl font-bold text-white mb-4">How to Play</h2>
        <div className="bg-dark-lighter rounded-lg p-6 border border-gray-700">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-dark p-4 rounded-lg">
              <div className="text-xl font-bold text-purple-400 mb-2">1. Choose Your Mode</div>
              <p className="text-gray-300">Select from Duel, AI Agent, or Solo Play based on your preference</p>
            </div>
            <div className="bg-dark p-4 rounded-lg">
              <div className="text-xl font-bold text-purple-400 mb-2">2. Master the Controls</div>
              <p className="text-gray-300">Use your mouse to aim and control shot power with precision</p>
            </div>
            <div className="bg-dark p-4 rounded-lg">
              <div className="text-xl font-bold text-purple-400 mb-2">3. Win & Earn</div>
              <p className="text-gray-300">Climb the leaderboard, complete quests, and earn rewards</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BitPool;
